import axios from 'axios';
import {reqExpost,ajaxGet,ajaxPost,ajaxDelete,ajaxPut,ajaxPatch,uploadImg,ajaxGetDetailByID,ajaxDownloadExcel} from './request';
import {url} from './url';

// 获取登录页的信息
export const login = params => ajaxPost({url: `token/`,params})
// 获取验证码
export const getCaptcha = params => ajaxGet({url: `captcha/`,params})
// 获取菜单
export const apiSystemWebRouter = params => ajaxGet({url: `system/menu/web_router/`,params})
//系统监控
export const monitorGetSystemInfo = params => ajaxGet({url: `monitor/getsysteminfo/`,params})
// 获取系统所有api列表
export const getSystemLyapiList = params => ajaxGet({url: `lyapi.json`,params})

/**
*系统配置
 * */

// 系统配置
export const platformsettingsSysconfig = params => ajaxGet({url: `platformsettings/sysconfig/`,params})
// 系统配置 -- 新增
export const platformsettingsSysconfigAdd = params => ajaxPost({url: `platformsettings/sysconfig/`,params})
// 系统配置 -- 编辑
export const platformsettingsSysconfigEdit = params => ajaxPut({url: `platformsettings/sysconfig/`,params})
// 系统配置 -- 删除
export const platformsettingsSysconfigDelete = params => ajaxDelete({url: `platformsettings/sysconfig/`,params})
// 系统配置 -- 保存子项
export const platformsettingsSysconfigSavecontent = params => ajaxPut({url: `platformsettings/sysconfig/save_content/`,params})


// 获取销售列表
export const baobeiGetsalerlist = params => ajaxGet({url: `baobei/getsalerlist/`,params})

/**
*使用规则
 * */

// 使用规则
export const baobeiUserule = params => ajaxGet({url: `baobei/userule/`,params})
// 使用规则 -- 新增
export const baobeiUseruleAdd = params => ajaxPost({url: `baobei/userule/`,params})
// 使用规则 -- 编辑
export const baobeiUseruleEdit = params => ajaxPut({url: `baobei/userule/`,params})
// 使用规则 -- 删除
export const baobeiUseruleDelete = params => ajaxDelete({url: `baobei/userule/`,params})
// 使用规则 -- 保存子项
export const baobeiUseruleSavecontent = params => ajaxPut({url: `baobei/userule/save_content/`,params})

//行业管理
export const baobeiIndustry= params => ajaxGet({url: `baobei/industry/`,params})
// 行业管理 新增
export const baobeiIndustryAdd= params => ajaxPost({url: `baobei/industry/`,params})
// 行业管理 编辑
export const baobeiIndustryEdit= params => ajaxPut({url: `baobei/industry/`,params})
// 行业管理 删除
export const baobeiIndustryDelete= params => ajaxDelete({url: `baobei/industry/`,params})
// 行业管理 禁用状态
export const baobeiIndustryDisablestatus= params => ajaxPut({url: `baobei/industry/disablestatus/`,params})

//产品管理
export const baobeiProduct= params => ajaxGet({url: `baobei/product/`,params})
// 产品管理 新增
export const baobeiProductAdd= params => ajaxPost({url: `baobei/product/`,params})
// 产品管理 编辑
export const baobeiProductEdit= params => ajaxPut({url: `baobei/product/`,params})
// 产品管理 删除
export const baobeiProductDelete= params => ajaxDelete({url: `baobei/product/`,params})
// 产品管理 禁用状态
export const baobeiProductDisablestatus= params => ajaxPut({url: `baobei/product/disablestatus/`,params})

//区域管理
export const baobeiArea= params => ajaxGet({url: `baobei/area/`,params})
// 区域管理 新增
export const baobeiAreaAdd= params => ajaxPost({url: `baobei/area/`,params})
// 区域管理 编辑
export const baobeiAreaEdit= params => ajaxPut({url: `baobei/area/`,params})
// 区域管理 删除
export const baobeiAreaDelete= params => ajaxDelete({url: `baobei/area/`,params})
// 区域管理 禁用状态
export const baobeiAreaDisablestatus= params => ajaxPut({url: `baobei/area/disablestatus/`,params})

/**
*消息中心
 * */

//消息中心
export const baobeiMsgcenter = params => ajaxGet({url: `baobei/msgcenter/`,params})
//消息中心-新增
export const baobeiMsgcenterAdd = params => ajaxPost({url: `baobei/msgcenter/`,params})
//消息中心-修改
export const baobeiMsgcenterEdit = params => ajaxPut({url: `baobei/msgcenter/`,params})
//消息中心-删除
export const baobeiMsgcenterDelete = params => ajaxDelete({url: `baobei/msgcenter/`,params})

/**
*邮件记录
 * */

//邮件记录
export const baobeiEmailcenter = params => ajaxGet({url: `baobei/emailcenter/`,params})
//邮件记录-新增
export const baobeiEmailcenterAdd = params => ajaxPost({url: `baobei/emailcenter/`,params})
//邮件记录-修改
export const baobeiEmailcenterEdit = params => ajaxPut({url: `baobei/emailcenter/`,params})
//邮件记录-删除
export const baobeiEmailcenterDelete = params => ajaxDelete({url: `baobei/emailcenter/`,params})

/**
*计划任务
 * */

// 计划任务
export const crontabPeriodictask = params => ajaxGet({url: `crontab/periodictask/`,params})
// 计划任务 -- 新增
export const crontabPeriodictaskAdd = params => ajaxPost({url: `crontab/periodictask/`,params})
// 计划任务 -- 编辑
export const crontabPeriodictaskEdit = params => ajaxPut({url: `crontab/periodictask/`,params})
// 计划任务 -- 删除
export const crontabPeriodictaskDelete = params => ajaxDelete({url: `crontab/periodictask/`,params})
// 计划任务 -- 开始/暂停
export const crontabPeriodictaskEnabled = params => ajaxPut({url: `crontab/periodictask/enabled/`,params})
// 计划任务 获取本地所有tasks文件中的task任务方法
export const crontabPeriodictaskMethodlist = params => ajaxGet({url: `crontab/periodictask/tasklist/`,params})

// 计划任务 获取任务执行结果
export const crontabTaskresult = params => ajaxGet({url: `crontab/taskresult/`,params})


/**
*终端服务
 * */

// 终端服务
export const apiTerminal = params => ajaxGet({url: `terminal/terminal/`,params})
// 终端服务 -- 新增
export const apiTerminalAdd = params => ajaxPost({url: `terminal/terminal/`,params})
// 终端服务 -- 编辑
export const apiTerminalEdit = params => ajaxPut({url: `terminal/terminal/`,params})
// 终端服务 -- 删除
export const apiTerminalDelete = params => ajaxDelete({url: `terminal/terminal/`,params})

/**
*系统管理
 * */
// 部门管理列表
export const apiSystemDept = params => ajaxGet({url: `system/dept/`,params})
// 部门管理列表 -- 新增部门
export const apiSystemDeptAdd = params => ajaxPost({url: `system/dept/`,params})
// 部门管理列表 -- 编辑部门
export const apiSystemDeptEdit = params => ajaxPut({url: `system/dept/`,params})
// 部门管理列表 -- 删除部门
export const apiSystemDeptDelete = params => ajaxDelete({url: `system/dept/`,params})


// 菜单管理列表
export const apiSystemMenu = params => ajaxGet({url: `system/menu/`,params})
// 菜单管理列表 -- 新增菜单
export const apiSystemMenuAdd = params => ajaxPost({url: `system/menu/`,params})
// 菜单管理列表 -- 编辑菜单
export const apiSystemMenuEdit = params => ajaxPut({url: `system/menu/`,params})
// 菜单管理列表 -- 删除菜单
export const apiSystemMenuDelete = params => ajaxDelete({url: `system/menu/`,params})
//获取部门数据,获取菜单树
export const systemMenuTree = params => ajaxGet({url: `system/menu_tree/`,params})
// 菜单管理 》 按钮列表(全部)
export const systemButton = params => ajaxGet({url:`system/button/`,params})
// 菜单管理 》 按钮 编辑
export const systemButtonEdit = params => ajaxPut({url:`system/button/`,params})
// 菜单管理 》 按钮 新增
export const systemButtonAdd = params => ajaxPost({url:`system/button/`,params})
// 菜单管理 》 按钮 删除
export const systemButtonDelete = params => ajaxDelete({url:`system/button/`,params})
// 菜单管理 》 按钮配置列表（针对单个菜单）
export const systemMenuButton = params => ajaxGet({url:`system/menu_button/`,params})
// 菜单管理 》 按钮配置列表（针对单个菜单） 新增
export const systemMenuButtonAdd = params => ajaxPost({url:`system/menu_button/`,params})
// 菜单管理 》 按钮配置列表（针对单个菜单） 编辑
export const systemMenuButtonEdit = params => ajaxPut({url:`system/menu_button/`,params})
// 菜单管理 》 按钮配置列表（针对单个菜单） 删除
export const systemMenuButtonDelete = params => ajaxDelete({url:`system/menu_button/`,params})



// 角色管理列表
export const apiSystemRole = params => ajaxGet({url: `system/role/`,params})
// 角色管理列表-修改
export const apiSystemRoleEdit = params => ajaxPut({url: `system/role/`,params})
// 角色管理列表 -- 新增角色
export const apiSystemRoleAdd = params => ajaxPost({url: `system/role/`,params})
// 角色管理列表 -- 新增角色
export const apiSystemRoleDelete = params => ajaxDelete({url: `system/role/`,params})
//获取部门数据,用于角色授权
export const apiSystemDeptTree = params => ajaxGet({url: `system/dept_tree/`,params})
//通过角色id,获取菜单数据
export const apiSystemRoleIdToMenu = params => ajaxGet({url: `system/role_id_to_menu/`,params})
export const apiSystemRoleIdToMenuid = (id) => ajaxGet({url: `system/role_id_to_menu/`+id+'/'})

//权限管理
// 权限管理 -- 保存
export const apiPermissionSave = params => ajaxPut({url: `system/permission/`,params})

//管理员管理
export const apiSystemUser = params => ajaxGet({url: `system/user/`,params})
//管理员管理-新增
export const apiSystemUserAdd = params => ajaxPost({url: `system/user/`,params})
//管理员管理-修改
export const apiSystemUserEdit = params => ajaxPut({url: `system/user/`,params})
//管理员管理-删除
export const apiSystemUserDelte = params => ajaxDelete({url: `system/user/`,params})

/**
 *日志管理
 * */
// 日志管理 查询
export const systemOperationlog= params => ajaxGet({url: `system/operation_log/`,params})
// 日志管理 自己的操作日志
export const systemGetOwnerLogs= params => ajaxGet({url: `system/operation_log/getOwnerLogs/`,params})
// 日志管理 删除
export const systemOperationlogDelete= params => ajaxDelete({url: `system/operation_log/`,params})
// 日志管理 清空全部日志
export const systemOperationlogDeletealllogsDelete= params => ajaxDelete({url: `system/operation_log/deletealllogs/`,params})

/**
 *个人中心
 * */
// 获取当前个人用户信息
export const systemUserUserInfo= params => ajaxGet({url: `system/user/user_info/`,params})
// 更新修改当前个人用户信息
export const systemUserUserInfoEdit= params => ajaxPut({url: `system/user/user_info/`,params})
// 用户重置个人密码
export const systemUserChangePassword= params => ajaxPut({url: `system/user/change_password/`,params})


/**
 *消息中心
 * */
//消息模板
export const messagesMessagetemplate = params => ajaxGet({url: `messages/messagetemplate/`,params})
//消息模板-新增
export const messagesMessagetemplateAdd = params => ajaxPost({url: `messages/messagetemplate/`,params})
//消息模板-修改
export const messagesMessagetemplateEdit = params => ajaxPut({url: `messages/messagetemplate/`,params})
//消息模板-删除
export const messagesMessagetemplateDelete = params => ajaxDelete({url: `messages/messagetemplate/`,params})

//消息公告
export const messagesMessagenotice = params => ajaxGet({url: `messages/messagenotice/`,params})
//消息公告-新增
export const messagesMessagenoticeAdd = params => ajaxPost({url: `messages/messagenotice/`,params})
//消息公告-修改
export const messagesMessagenoticeEdit = params => ajaxPut({url: `messages/messagenotice/`,params})
//消息公告-删除
export const messagesMessagenoticeDelete = params => ajaxDelete({url: `messages/messagenotice/`,params})



/**
 *省市区选择
 * */
// 省市区选择  获取省
export const getProvince= params => ajaxGet({url: `areas/`,params})
// 省市区选择  获取市/区
export const getCityDistrictByID= params => ajaxGetDetailByID({url: `areas/`,params})

// 省市区选择  根据详细地址获取经纬度
export const getAddressaccuracy= params => ajaxGet({url: `getaddressaccuracy/`,params})


/**
 *意见反馈
 * */

// 意见反馈 列表
export const PlatformsettingsUserfeeckback= params => ajaxGet({url: `platformsettings/userfeeckback/`,params})
// 意见反馈 新增
export const PlatformsettingsUserfeeckbackAdd= params => ajaxPost({url: `platformsettings/userfeeckback/`,params})
// 意见反馈 编辑
export const PlatformsettingsUserfeeckbackEdit= params => ajaxPut({url: `platformsettings/userfeeckback/`,params})
// 意见反馈 删除
export const PlatformsettingsUserfeeckbackDelete= params => ajaxDelete({url: `platformsettings/userfeeckback/`,params})

/**
 *地区管理
 * */

// 地区管理列表
export const addressArea = params => ajaxGet({url: `address/area/`,params})
// 地区管理列表 获取根地区
export const addressAreaRoot = params => ajaxGet({url: `address/area/area_root/`,params})
// 地区管理列表 -- 新增
export const addressAreaAdd = params => ajaxPost({url: `address/area/`,params})
// 地区管理列表 -- 编辑
export const addressAreaEdit = params => ajaxPut({url: `address/area/`,params})
// 地区管理列表 -- 删除
export const addressAreaDelete = params => ajaxDelete({url: `address/area/`,params})

/**
 *商城管理
 * */

// 商品分类 列表
export const mallGoodstype= params => ajaxGet({url: `mall/goodstype/`,params})
// 商品分类 新增
export const mallGoodstypeAdd= params => ajaxPost({url: `mall/goodstype/`,params})
// 商品分类 编辑
export const mallGoodstypeEdit= params => ajaxPut({url: `mall/goodstype/`,params})
// 商品分类 删除
export const mallGoodstypeDelete= params => ajaxDelete({url: `mall/goodstype/`,params})

// 商品管理 列表
export const mallGoodsspu= params => ajaxGet({url: `mall/goodsspu/`,params})
// 商品管理 新增
export const mallGoodsspuAdd= params => ajaxPost({url: `mall/goodsspu/`,params})
// 商品管理 编辑
export const mallGoodsspuEdit= params => ajaxPut({url: `mall/goodsspu/`,params})
// 商品管理 删除
export const mallGoodsspuDelete= params => ajaxDelete({url: `mall/goodsspu/`,params})

// 商品管理 上下架
export const mallGoodsspuIslaunched= params => ajaxPut({url: `mall/goodsspu/islaunched/`,params})

// 商品管理 修改商品SKU价格
export const mallGoodsspueEditskups= params => ajaxPut({url: `mall/goodsspu/editskups/`,params})

// 商城订单 列表
export const mallGoodsOrder= params => ajaxGet({url: `mall/goodsorder/`,params})
// 商城订单 新增
export const mallGoodsOrderAdd= params => ajaxPost({url: `mall/goodsorder/`,params})
// 商城订单 编辑
export const mallGoodsOrderEdit= params => ajaxPut({url: `mall/goodsorder/`,params})
// 商城订单 删除
export const mallGoodsOrderDelete= params => ajaxDelete({url: `mall/goodsorder/`,params})

// 商城订单 发货
export const mallGoodsSendoutgoods= params => ajaxPost({url: `mall/goodsorder/sendoutgoods/`,params})

// 商城订单 订单价格 订单量统计
export const mallGoodsOrderstatistics= params => ajaxGet({url: `mall/goodsorder/orderstatistics/`,params})

//营销管理

// 优惠券管理 列表
export const mallGoodscoupon= params => ajaxGet({url: `mall/goodscoupon/`,params})
// 优惠券管理 新增
export const mallGoodscouponAdd= params => ajaxPost({url: `mall/goodscoupon/`,params})
// 优惠券管理 编辑
export const mallGoodscouponEdit= params => ajaxPut({url: `mall/goodscoupon/`,params})
// 优惠券管理 删除
export const mallGoodscouponDelete= params => ajaxDelete({url: `mall/goodscoupon/`,params})

// 优惠券记录 列表
export const mallCouponrecord= params => ajaxGet({url: `mall/couponrecord/`,params})
// 优惠券记录 新增
export const mallCouponrecordAdd= params => ajaxPost({url: `mall/couponrecord/`,params})
// 优惠券记录 编辑
export const mallCouponrecordEdit= params => ajaxPut({url: `mall/couponrecord/`,params})
// 优惠券记录 删除
export const mallCouponrecordDelete= params => ajaxDelete({url: `mall/couponrecord/`,params})

/**
 * 财务统计
 * **/

//商品订单统计
export const mallGoodsforderinfo= params => ajaxGet({url: `mall/goodsforderinfo/`,params})
// 商品订单统计 新增
export const mallGoodsforderinfoAdd= params => ajaxPost({url: `mall/goodsforderinfo/`,params})
// 商品订单统计 编辑
export const mallGoodsforderinfoEdit= params => ajaxPut({url: `mall/goodsforderinfo/`,params})
// 商品订单统计 删除
export const mallGoodsforderinfoDelete= params => ajaxDelete({url: `mall/goodsforderinfo/`,params})
// 商品订单统计 总金额统计
export const mallGoodsforderinfoOrderstatistics= params => ajaxGet({url: `mall/goodsforderinfo/orderstatistics/`,params})

/**
 *草稿箱管理
 * */

// 草稿箱管理 列表
export const baobeiDrafts= params => ajaxGet({url: `baobei/drafts/`,params})
// 草稿箱管理 新增
export const baobeiDraftsAdd= params => ajaxPost({url: `baobei/drafts/`,params})
// 草稿箱管理 编辑
export const baobeiDraftsEdit= params => ajaxPut({url: `baobei/drafts/`,params})
// 草稿箱管理 删除
export const baobeiDraftsDelete= params => ajaxDelete({url: `baobei/drafts/`,params})
// 草稿箱管理 提交报备
export const baobeiDraftsSubmitReport= params => ajaxPost({url: `baobei/drafts/submitReport/`,params})


export const baobeiGetUserInfo= params => ajaxGet({url: `baobei/getuserinfo/`,params})

/**
 *报备管理
 * */

// 报备管理 列表
export const baobeiReport= params => ajaxGet({url: `baobei/report/`,params})
// 报备管理 新增
export const baobeiReportAdd= params => ajaxPost({url: `baobei/report/`,params})
// 报备管理 编辑
export const baobeiReportEdit= params => ajaxPut({url: `baobei/report/`,params})
// 报备管理 删除
export const baobeiReportDelete= params => ajaxDelete({url: `baobei/report/`,params})
// 报备管理 用户撤销报备
export const baobeiReportCancelReport= params => ajaxPut({url: `baobei/report/cancelReport/`,params})
// 报备管理 平台撤销报备
export const baobeiReportSystemCancelReport= params => ajaxPut({url: `baobei/report/systemCancelReport/`,params})

// 报备管理 审批详情流程列表
export const baobeiReportDetail= (id)=> ajaxGet({url: `baobei/report/getAuditDeial/`+id+'/'})

// 报备管理 销售审批
export const baobeiReportSalerAuditApprove= params=> ajaxPut({url: `baobei/report/salerAuditApprove/`,params})
// 报备管理 复核员审批
export const baobeiReportReviewerAuditApprove= params=> ajaxPut({url: `baobei/report/reviewerAuditApprove/`,params})

// 报备管理 -- 导出
export const baobeiReportExport = (urlparams,params) => ajaxDownloadExcel({url: `baobei/report/export/${urlparams}`,params})

// 报备审核 列表
export const baobeiReportAudit= params => ajaxGet({url: `baobei/reportAduit/`,params})
// 报备审核 -- 导出
export const baobeiReportAuditExport = (urlparams,params) => ajaxDownloadExcel({url: `baobei/reportAduit/export/${urlparams}`,params})

/**
 *用户管理
 * */

// 用户管理 列表
export const UsersUsers= params => ajaxGet({url: `users/users/`,params})
// 用户管理 新增
export const UsersUsersAdd= params => ajaxPost({url: `users/users/`,params})
// 用户管理 编辑
export const UsersUsersEdit= params => ajaxPut({url: `users/users/`,params})
// 用户管理 删除
export const UsersUsersDelete= params => ajaxDelete({url: `users/users/`,params})
// 用户管理 禁用用户
export const UsersUsersdisableEdit= params => ajaxPut({url: `users/users/disableuser/`,params})
// 用户管理 导出
export const UsersUsersExportexecl= params => ajaxGet({url: `users/users/exportexecl/`,params})
// 用户管理 重置密码
export const UsersUsersResetPassword= params => ajaxPut({url: `users/users/resetpassword/`,params})
// 用户管理 离岗继承
export const UsersUsersleaveInherit= params => ajaxPut({url: `users/users/leave_inherit/`,params})

/**
 *代理商管理
 * */

// 代理商管理 列表
export const UsersAgentusers= params => ajaxGet({url: `users/agentuser/`,params})
// 代理商管理 新增
export const UsersAgentusersAdd= params => ajaxPost({url: `users/agentuser/`,params})
// 代理商管理 编辑
export const UsersAgentusersEdit= params => ajaxPut({url: `users/agentuser/`,params})
// 代理商管理 删除
export const UsersAgentusersDelete= params => ajaxDelete({url: `users/agentuser/`,params})
// 代理商管理 禁用用户
export const UsersAgentusersdisableEdit= params => ajaxPut({url: `users/agentuser/disableuser/`,params})
// 代理商管理 重置用户密码
export const UsersAgentusersResetpassword= params => ajaxPut({url: `users/agentuser/resetpassword/`,params})

/**
 *复核员管理
 * */

// 复核员管理 列表
export const UsersCheckusers= params => ajaxGet({url: `users/checkuser/`,params})
// 复核员管理 新增
export const UsersCheckusersAdd= params => ajaxPost({url: `users/checkuser/`,params})
// 复核员管理 编辑
export const UsersCheckusersEdit= params => ajaxPut({url: `users/checkuser/`,params})
// 复核员管理 删除
export const UsersCheckusersDelete= params => ajaxDelete({url: `users/checkuser/`,params})
// 复核员管理 禁用用户
export const UsersCheckusersdisableEdit= params => ajaxPut({url: `users/checkuser/disableuser/`,params})
// 复核员管理 重置用户密码
export const UsersCheckusersResetpassword= params => ajaxPut({url: `users/checkuser/resetpassword/`,params})

/**
*平台设置
*/
//轮播图列表
export const platformsettingsLunboimg= params => ajaxGet({url: `platformsettings/lunboimg/`,params})
// 轮播图列表 新增
export const platformsettingsLunboimgAdd= params => ajaxPost({url: `platformsettings/lunboimg/`,params})
// 轮播图列表 编辑
export const platformsettingsLunboimgEdit= params => ajaxPut({url: `platformsettings/lunboimg/`,params})
// 轮播图列表 删除
export const platformsettingsLunboimgDelete= params => ajaxDelete({url: `platformsettings/lunboimg/`,params})


//其他设置
export const platformsettingsOther= params => ajaxGet({url: `platformsettings/other/`,params})
// 其他设置 新增
export const platformsettingsOtherAdd= params => ajaxPost({url: `platformsettings/other/`,params})
// 其他设置 编辑
export const platformsettingsOtherEdit= params => ajaxPut({url: `platformsettings/other/`,params})
// 其他设置 删除
export const platformsettingsOtherDelete= params => ajaxDelete({url: `platformsettings/other/`,params})

// 平台设置 图片上传
export const platformsettingsUploadPlatformImg= params => uploadImg({url: `platformsettings/uploadplatformimg/`,params})

//前端访问操作 获取
export const superOerateGet= params => ajaxGet({url: `super/operate/`,params})
//前端访问操作 设置
export const superOerateSet= params => ajaxPost({url: `super/operate/`,params})